{
  "INBOX": {
    "LIST": {
      "TITLE": "Saját bejövő",
      "DISPLAY_DROPDOWN": "Megjelenítés",
      "LOADING": "Értesítések lekérése",
      "404": "Ebben a csoportban nincsenek aktív értesítések.",
      "NO_NOTIFICATIONS": "Nincs értesítés",
      "NOTE": "Értesítés az összes feliratkozott postafiókból",
      "NO_MESSAGES_AVAILABLE": "Hoppá! Az üzenetek betöltése nem sikerült",
      "SNOOZED_UNTIL": "Halasztás eddig",
      "SNOOZED_UNTIL_TOMORROW": "Halasztás holnapig",
      "SNOOZED_UNTIL_NEXT_WEEK": "Halasztás jövő hétig"
    },
    "ACTION_HEADER": {
      "SNOOZE": "Értesítés alvó állapotban",
      "DELETE": "Értesítés törlése",
      "BACK": "Vissza"
    },
    "TYPES": {
      "CONVERSATION_MENTION": "Önt megemlítették egy beszélgetésben",
      "CONVERSATION_CREATION": "Új beszélgetés létrehozása",
      "CONVERSATION_ASSIGNMENT": "Egy beszélgetés hozzád lett rendelve",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Új üzenet egy kijelölt beszélgetésben",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Új üzenet egy beszélgetésben, amelyben részt vesz",
      "SLA_MISSED_FIRST_RESPONSE": "A beszélgetés nem teljesítette az első válaszra vonatkozó SLA-célt",
      "SLA_MISSED_NEXT_RESPONSE": "A beszélgetés nem teljesítette a következő válaszra vonatkozó SLA-célt",
      "SLA_MISSED_RESOLUTION": "A beszélgetés nem teljesítette a megoldásra vonatkozó SLA-célt"
    },
    "TYPES_NEXT": {
      "CONVERSATION_MENTION": "Említések",
      "CONVERSATION_ASSIGNMENT": "Önhöz rendelve",
      "CONVERSATION_CREATION": "Új beszélgetés",
      "SLA_MISSED_FIRST_RESPONSE": "SLA-sértés",
      "SLA_MISSED_NEXT_RESPONSE": "SLA-sértés",
      "SLA_MISSED_RESOLUTION": "SLA-sértés",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Új üzenet",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Új üzenet",
      "SNOOZED_UNTIL": "Halasztva: {time}",
      "SNOOZED_ENDS": "A halasztás lejárt",
      "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Új üzenet"
    },
    "NO_CONTENT": "Nincs elérhető tartalom",
    "PHONE_CALL_TYPES": {
      "OUTBOUND_CONNECTED": "Kimenő hívás - Kapcsolódva",
      "OUTBOUND_FAILED": "Kimenő hívás - Sikertelen",
      "INBOUND_MISSED": "Bejövő hívás - Nem fogadott",
      "INBOUND_UNANSWERED_MISSED": "Bejövő hívás - Megválaszolatlan nem fogadott",
      "INBOUND_AGENT": "Bejövő hívás - Ügynök által fogadott",
      "INBOUND_IVR": "Bejövő hívás - IVR által fogadott",
      "DEFAULT": "Telefonhívás"
    },
    "MENU_ITEM": {
      "MARK_AS_READ": "Megjelölés olvasottként",
      "MARK_AS_UNREAD": "Megjelölés olvasatlanként",
      "SNOOZE": "Halasztás",
      "DELETE": "Törlés",
      "MARK_ALL_READ": "Mindent olvasottra állít",
      "DELETE_ALL": "Összes törlése",
      "DELETE_ALL_READ": "Összes olvasott törlése"
    },
    "DISPLAY_MENU": {
      "SORT": "Rendezés",
      "DISPLAY": "Megjelenítés:",
      "SORT_OPTIONS": {
        "NEWEST": "Legújabb",
        "OLDEST": "Legrégibb",
        "PRIORITY": "Prioritás"
      },
      "DISPLAY_OPTIONS": {
        "SNOOZED": "Elnémított",
        "READ": "Olvasott",
        "LABELS": "Cimkék",
        "CONVERSATION_ID": "Beszélgetés azonosítója"
      }
    },
    "ALERTS": {
      "MARK_AS_READ": "Értesítés olvasottnak jelölve",
      "MARK_AS_UNREAD": "Értesítés olvasatlannak jelölve",
      "SNOOZE": "Értesítés halasztva",
      "DELETE": "Értesítés törölve",
      "MARK_ALL_READ": "Az összes értesítés olvasottnak jelölve",
      "DELETE_ALL": "Az összes értesítés törölve",
      "DELETE_ALL_READ": "Az összes olvasott értesítés törölve"
    }
  }
}
